module.exports = __webpack_public_path__ + "static/assets/f3dd8b0915b3be6231a14957528cc7fd.svg";